import { ImagesLayout } from 'components/library/images/ImagesLayout';
import { useDrag } from 'react-dnd';
import { GridBlockType } from 'services/entities/BlockTypes';
import { useImageSelect } from './ImageSelectContext';

export const DraggableImage = ({ url, title }: { url: string; title: string }) => {
  const { onSelect } = useImageSelect();

  const [, drag] = useDrag(
    () => ({
      type: GridBlockType.IMAGE,
      item: {
        src: url,
      },
    }),
    [url]
  );

  return (
    <div ref={drag} style={{ cursor: 'pointer', width: '100%' }} onClick={() => onSelect?.(url)}>
      <ImagesLayout.GalleryTile>
        <ImagesLayout.GalleryTileImage url={url} title={title} />
      </ImagesLayout.GalleryTile>
    </div>
  );
};
